import type { IPost } from "../../../../types/models/post.models.types";
import { usePutHttp } from "../../http.hook";

export interface IPostResponse {
  post: IPost;
}

interface IBody {
  message: string;
}


export function usePostsRejectPostAdminHttp() {
  return usePutHttp<IBody, IPostResponse>({
    path: "/admin/posts/:id/reject-post",
  });
}
